import { ClockInState } from '@/store/clockIn/types'

const state: ClockInState = {
  clockIns: [],
  stamps: [],
};

export default state;
